import getConfig from "next/config"
const { publicRuntimeConfig } = getConfig() || {}

const loadEnv = () => publicRuntimeConfig || {}

const getLogObject = (level, message, environment, data, attributes) => ({
    attributes: {
        timestamp: new Date().toISOString(),
        ...attributes,
    },
    message: message,
    level: level,
    service: "make-it-butter",
    environment: environment,
    ...(data ? { data: data } : null),
})

const log = (level, message, data, attributes) => {
    const envVars = loadEnv()

    if (envVars.NODE_ENV === "development") {
        // eslint-disable-next-line no-console
        console.log(message, data, attributes)
    } else if (typeof window !== "undefined") {
        const url = new URL(window.location.href)
        fetch(`${url.origin}/log`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                message: message,
                data: data,
                level: level,
                attributes: attributes,
            }),
        }).catch((err) => {
            // eslint-disable-next-line no-console
            console.error(err)
        })
    } else {
        // eslint-disable-next-line no-console
        console.log(JSON.stringify(getLogObject(level, message, envVars.ENVIRONMENT, data, attributes)))
    }
}

export default {
    log: log,
    info: (message: string, data?: any, attributes?: any) => log("info", message, data, attributes),
    warn: (message: string, data?: any, attributes?: any) => log("warn", message, data, attributes),
    error: (message: string, data?: any, attributes?: any) => log("error", message, data, attributes),
}
